<template>
    <AppLayoutBase>

        <template slot="main">
            <AuthResetPasswordContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>